export default __webpack_public_path__ + "static/media/pennant.2b719b01.svg";